import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselWrapper, Slide, SlideImage } from "./JindalTyreCarousel.styles";
import shopfront from "../../images/division_jindal_tyres.webp";
import tyreShop2 from "../../images/jindal_tyre_shop_2.webp";
import tyreShop3 from "../../images/jindal_tyre_shop_3.webp";

const slides = [
  { src: shopfront, alt: "Jindal Tyre shopfront" },
  { src: tyreShop2, alt: "Jindal Tyre — premium tyre display" },
  { src: tyreShop3, alt: "Jindal Tyre — tyre changing and service bay" },
];

const JindalTyreCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
  };

  return (
    <CarouselWrapper>
      <Slider {...settings}>
        {slides.map((item) => (
          <Slide key={item.alt}>
            <SlideImage src={item.src} alt={item.alt} />
          </Slide>
        ))}
      </Slider>
    </CarouselWrapper>
  );
};

export default JindalTyreCarousel;
